// src/components/TrocarSenhaObrigatoria.jsx
import React, { useState } from "react";
import authService from "../services/authService";

export default function TrocarSenhaObrigatoria({ usuario, onTrocada }) {
  const [senha,     setSenha]     = useState("");
  const [confirma,  setConfirma]  = useState("");
  const [erro,      setErro]      = useState("");
  const [salvando,  setSalvando]  = useState(false);

  const handleSalvar = async (e) => {
    e.preventDefault();
    setErro("");
    if (senha.length < 6) return setErro("A senha deve ter ao menos 6 caracteres.");
    if (senha !== confirma) return setErro("As senhas não conferem.");
    setSalvando(true);
    try {
      // Primeiro acesso: o backend dispensa a senha atual (o JWT já comprova
      // que o usuário se autenticou com a senha temporária neste momento).
      const r = await authService.trocarSenha({ senha, confirmaSenha: confirma });
      // O backend rotaciona a tokenVersion ao trocar a senha. Se ele devolver
      // novos tokens, atualizamos o storage para manter a sessão atual viva
      // (caso contrário, o middleware invalidaria o JWT antigo e cairia em
      // "faça login novamente").
      if (r?.accessToken)  localStorage.setItem("accessToken",  r.accessToken);
      if (r?.refreshToken) localStorage.setItem("refreshToken", r.refreshToken);
      onTrocada();
    } catch(e) {
      setErro(e?.message || "Erro ao trocar a senha. Tente novamente.");
    }
    setSalvando(false);
  };

  return (
    <div style={{
      minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center",
      background:"linear-gradient(135deg,#1B3A6B 0%,#2563EB 100%)", padding:"20px",
    }}>
      <div style={{
        background:"var(--bg-surface)", borderRadius:16, padding:"40px 36px", width:"100%",
        maxWidth:420, boxShadow:"0 32px 64px rgba(0,0,0,.25)",
      }}>
        <div style={{textAlign:"center",marginBottom:28}}>
          <div style={{fontSize:48,marginBottom:12}}>🔐</div>
          <h2 style={{fontWeight:800,fontSize:22,color:"#1B3A6B",margin:0}}>
            Troque sua senha
          </h2>
          <p style={{color:"var(--gray-500)",fontSize:13,marginTop:8}}>
            Para continuar, defina uma nova senha pessoal.
          </p>
        </div>

        {erro && (
          <div style={{background:"var(--bg-danger-soft)",border:"1px solid #FCA5A5",borderRadius:8,
            padding:"10px 14px",marginBottom:16,color:"#991B1B",fontSize:13}}>
            <i className="bi bi-exclamation-circle me-2"/>{erro}
          </div>
        )}

        <div style={{
          background:"var(--bg-warning-soft)",border:"1px solid #FDE047",borderRadius:8,
          padding:"10px 14px",marginBottom:20,fontSize:12.5,color:"#713F12",
        }}>
          ⚠️ Você está usando uma <strong>senha temporária</strong>. Crie uma senha segura antes de continuar.
        </div>

        <form onSubmit={handleSalvar}>
          <div style={{marginBottom:16}}>
            <label style={{fontWeight:600,fontSize:13,color:"#374151",display:"block",marginBottom:6}}>
              Nova Senha
            </label>
            <input type="password" className="form-control" value={senha}
              onChange={e=>setSenha(e.target.value)}
              placeholder="Mínimo 6 caracteres" autoFocus/>
          </div>
          <div style={{marginBottom:24}}>
            <label style={{fontWeight:600,fontSize:13,color:"#374151",display:"block",marginBottom:6}}>
              Confirmar Nova Senha
            </label>
            <input type="password" className="form-control" value={confirma}
              onChange={e=>setConfirma(e.target.value)}
              placeholder="Repita a nova senha"/>
          </div>
          <button type="submit" className="btn btn-primary w-100"
            style={{padding:"12px",fontWeight:700,fontSize:15,borderRadius:10}}
            disabled={salvando}>
            {salvando
              ? <><span className="spinner-border spinner-border-sm me-2"/>Salvando...</>
              : "Definir Nova Senha e Entrar →"}
          </button>
        </form>
      </div>
    </div>
  );
}
